/**
 * vue quill editor 配置
 */
import localStorage from 'store';

// 图片上传配置
const uploadConfig = {
  // action:  '/app/upload_quill_image',      // 必填，图片上传地址
  action:  'https://adminapi.love1234.com/app/upload_quill_image', // 线上
  // action:  'http://adminapi.newbee.com/app/upload_quill_image', // 本地

  methods: 'POST',          // 必填，图片上传方式
  token: localStorage.get('admin.token'), // 可选，如果需要token验证，假设你的token有存放在sessionStorage
  name: 'quillImage',       // 必填，文件的参数名
  size: 2048,               // 可选，图片大小，单位为Kb, 1M = 1024Kb
  accept: 'image/png, image/gif, image/jpeg',  // 可选，可上传的图片格式
  width: 600,
  height: 600
};

// 工具栏选项配置
const toolOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  // ["blockquote", "code-block"], // 引用  代码块
  // [{ 'header': 1 }, { 'header': 2 }], // 标题
  //[{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  // [{ script: "sub" }, { script: "super" }], // 上标/下标
  //[{ indent: "-1" }, { indent: "+1" }], // 缩进
  // [{'direction': 'rtl'}],            // 文本方向
  // [{ size: ["small", false, "large", "huge"] }], // 字体大小
  //[{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  // [{ font: [] }], // 字体种类
  //[{ align: [] }], // 对齐方式
  ["clean"], // 清除文本格式
  //["link", "image", "video"] // 链接、图片、视频
  ["link", "image", "video"] // 链接、图片、视频
];

// 事件重写
const handlers = {
  image: function image() {
    console.log(uploadConfig);
    let self = this;

    let fileInput = this.container.querySelector('input.ql-image[type=file]');
    if(fileInput == null) {
      fileInput = document.createElement('input');
      fileInput.setAttribute('type', 'file');
      // 设置图片参数名
      if(uploadConfig.name) {
        fileInput.setAttribute('name', uploadConfig.name);
      }

      // 设置上传图片的格式
      fileInput.setAttribute('accept', uploadConfig.accept);
      fileInput.classList.add('ql-image');

      // 监听选择文件事件
      fileInput.addEventListener('change', function() {
        let formData = new FormData();
        formData.append(uploadConfig.name, fileInput.files[0]);
        formData.append('object', 'product');

        // 图片上传
        let xhr = new XMLHttpRequest();
        xhr.open(uploadConfig.methods, uploadConfig.action, true);
		
		// 设置token
		if(uploadConfig.token) {
			console.log('设置token');
			xhr.setRequestHeader('Token', uploadConfig.token);
		}

        // 上传数据成功
        xhr.onload = function(){
          console.log('上传成功');
          if(xhr.status === 200) {
            console.log(xhr.responseText);
            let res = JSON.parse(xhr.responseText);
            if(res.code == '200') {
              let length = self.quill.getSelection(true).index;
              // 将图片地址插入到编辑器中
              console.log('path:' + res.data.path);
              self.quill.insertEmbed(length, 'image', res.data.path);
              self.quill.setSelection(length + 1);
            }
          }
          fileInput.value = '';
        };

        // 开始上传数提
        xhr.upload.onloadstart = function() {
          console.log('开始上传');
          fileInput.value = '';
        };

        // 网络异常
        xhr.upload.onerror = function() {
          console.log('网络异常');
        };

        // 上传结束，无论成功或失败都会触发
        xhr.upload.onloadend = function() {
          console.log('上传结束');
        };

        xhr.send(formData);
      });
      this.container.appendChild(fileInput);
    }
    fileInput.click();
  }
};

export default {
  placeholder: '',
  theme: 'snow',  // 主题
  modules: {
    toolbar: {
      container: toolOptions,   // 工具栏选项
      handlers: handlers        // 事件重写
    }
  }
}




